// constants.ts — Platform-wide constants

/** Public site title for display */
export const SITE_TITLE = import.meta.env.VITE_PLATFORM_TITLE ?? 'Kuro'

/** Dashboard route prefix */
export const DASHBOARD_ROOT = '/dashboard'

/** Default polling interval in milliseconds */
export const DEFAULT_REFRESH_INTERVAL = Number(
  import.meta.env.VITE_DEFAULT_REFRESH_INTERVAL ?? 60_000
)

/** Local storage key prefix */
export const STORAGE_PREFIX = 'kuro-platform'

/** Theme storage key */
export const THEME_STORAGE_KEY = `${STORAGE_PREFIX}:theme`

/** Snapshot storage key pattern: kuro-platform:snapshot:{module}:{endpoint} */
export const snapshotKey = (module: string, endpoint: string) =>
  `${STORAGE_PREFIX}:snapshot:${module}:${endpoint}`

/** Last visited module key */
export const LAST_MODULE_KEY = `${STORAGE_PREFIX}:last-module`

/** Default module path */
export const DEFAULT_MODULE = '/dashboard/kuroboard'

/** Freshness thresholds (ms) */
export const FRESHNESS = {
  /** Fresh: age <= 5 * refreshInterval */
  STALE_THRESHOLD_MULTIPLIER: 5,
  /** Stale -> Critical: age > 30 minutes */
  CRITICAL_THRESHOLD_MS: 30 * 60 * 1000,
} as const

/** Module IDs */
export const MODULE_IDS = ['kuroboard', 'kurotrader', 'goku-health', 'kuro-site', 'kuro'] as const
export type ModuleId = (typeof MODULE_IDS)[number]

/** Nav bar height in pixels */
export const TOP_NAV_HEIGHT = 48

/** Sidebar width in pixels */
export const SIDEBAR_WIDTH = 200
